import { z } from 'zod/v4';

// Vite aliases bare `zod` imports (also in @af/shared) to this configured facade.
// Use the v4 subpath here to avoid resolving the alias recursively.
export * from 'zod/v4';
export { default } from 'zod/v4';

// Zod 4 probes Function while constructing object schemas, even if parsing later
// falls back to the interpreter. Configure it before importing any browser schemas
// (including @af/shared) so strict CSP never sees that probe or generated parsers.
z.config({ jitless: true });
